export enum StoreTypeEnum {
  STORE = 'STORE',
  RELAYPOINT = 'RELAYPOINT',
  REPAIRER = 'REPAIRER',
  UPS = 'UPS',
  DPD = 'DPD',
  COLISSIMO = 'COLISSIMO',
  INPOST = 'INPOST',
  PACKETA = 'PACKETA',
  GLS = 'GLS',
  ECONT = 'ECONT',
  HERMES = 'HERMES'
}
